import httpClient from '@utils/httpClient.js';

export function updateButtonApiCall(options) {
  const { id, text, url, textAlign, shape, backgroundColor, textColor } = options;

  const profileId = localStorage.getItem('unilinkProfileId');

  return httpClient.put(`api/profiles/${profileId}/email-marketing/block/button`, {
    id,
    text,
    url,
    aligment: textAlign,
    shape,
    backgroundColor: backgroundColor,
    textColor: textColor,
  });
}
